export const WEBSITE = {
    DOMAIN: 'www.savingsseekerllc.com'
}